import api from "../services/api";

const service_path = '/customers-log.php';

/**
 * Lista o log de atividades dos CLIENTES (ações feitas na loja) com filtros e paginação.
 * @param {Object} filters - Filtros (todos opcionais)
 * @param {number} filters.page - Página (padrão: 1)
 * @param {number} filters.per_page - Itens por página (1-100, padrão: 20)
 * @param {string} filters.action - Ex: login, post, patch
 * @param {string} filters.entity_type - Ex: orders, quotes, customers
 * @param {number} filters.customer_id - ID do cliente
 * @param {string} filters.date_from - YYYY-MM-DD
 * @param {string} filters.date_to - YYYY-MM-DD
 */
export function getCustomersLogs(filters = {}) {
    const cleanFilters = Object.entries(filters).reduce((acc, [key, value]) => {
        if (value !== '' && value !== null && value !== undefined) {
            acc[key] = value;
        }
        return acc;
    }, {});

    const params = new URLSearchParams(cleanFilters).toString();
    const url = params ? `${service_path}?${params}` : service_path;

    return api.get(url);
}
